<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>权限配置 / 权限管理</span>
      </div>
      <div class="table-container scroll">
        <span class="role-manage-span">角色管理</span>
        <div class="role-container">
          <el-button
            v-for="item in roles"
            :key="item.middle"
            :class="activeRole === item.middle ? 'actived' : ''"
            type="primary"
            size="medium"
            plain
            @click="clickRole(item)"
            >{{ item.left }}</el-button
          >
        </div>
        <div class="add-person" v-if="roleG1">
          <span style="font-weight: 500">
            <span style="color: var(--theme-color)">{{ roleName }}</span>
            <span style="padding-left: 5px; color: #444444">成员列表</span>
          </span>
          <div style="margin-top: 20px; line-height: 50px;">
            <el-tag
              v-for="person in persons"
              style="margin-right: 20px"
              :key="person.value"
              type="info"
              closable
              @close="deletePerson(person)"
              >{{ person.name }}</el-tag
            >
            <el-button type="primary" size="medium" plain @click="addPerson"
              >+ 添加</el-button
            >
          </div>
        </div>
        <div class="permisson-set">
          <span style="font-weight: 500">
            <span style="color: var(--theme-color)">{{ roleName }}</span>
            <span style="padding-left: 5px; color: #444444">权限配置</span>
          </span>
          <el-table
            :data="permissionData"
            style="margin-top: 20px"
            size="medium"
            border
            :header-cell-style="{ background: '#f9f9f9' }"
          >
            <el-table-column label="功能模块" width="200">
              <template slot-scope="scope">
                <el-checkbox-group
                  v-model="scope.row.checkedModule"
                  @change="
                    (val) => {
                      changeModule(val, scope.row);
                    }
                  "
                >
                  <el-checkbox
                    :label="scope.row.t1.id"
                    :disabled="scope.row.t1.disabled"
                    >{{ scope.row.t1.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
            </el-table-column>
            <el-table-column label="功能要点">
              <template slot-scope="scope">
                <el-checkbox-group
                  v-model="scope.row.checkedPermission"
                  @change="
                    (val) => {
                      changePoint(val, scope.row);
                    }
                  "
                >
                  <template v-for="item in scope.row.t2">
                    <el-checkbox
                      :key="item.id"
                      :label="item.id"
                      :disabled="item.disabled"
                      >{{ item.name }}</el-checkbox
                    >
                  </template>
                </el-checkbox-group>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            type="primary"
            size="medium"
            style="margin-top: 20px"
            @click="saveConfig"
            >保存配置</el-button
          >
        </div>
      </div>
    </div>

    <add-permission-person
      :visible.sync="editorVisible"
      :identify="roleInfo"
      @edit-result="initMembers(activeRole)"
    ></add-permission-person>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import AddPermissionPerson from '@/components/common/AddPermissionPerson'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'add-permission-person': AddPermissionPerson
  },

  data () {
    return {
      roles: [],
      activeRole: null,
      persons: [],
      permissionData: [],
      clonedPermission: [],
      editorVisible: false,
      roleInfo: {}
    }
  },

  watch: {

  },

  computed: {
    _ () {
      return _
    },
    roleName () {
      let role = _.filter(this.roles, { middle: this.activeRole })[0]
      return role && role.left
    },
    roleG1 () {
      let role = _.filter(this.roles, { middle: this.activeRole })[0]
      return role && role.right
    }
  },

  mounted () {
    this.initPresetRole()
  },

  methods: {
    initPresetRole () {
      this.$xhrGet(`/acc/preset-roles`).then(rs => {
        this.roles = rs.data
        this.activeRole = rs.data[0].middle
        this.initMembers(rs.data[0].middle)
        this.initPermission(rs.data[0].middle)
      })
    },

    initMembers (role) {
      this.$xhrGet(`/acc/preset-roles/${role}/members`).then(rs => {
        this.persons = rs.data
      })
    },

    initPermission (role) {
      this.$xhrGet(`/acc/preset-roles/${role}/permissions`).then(rs => {
        for (let index = 0; index < rs.data.length; index++) {
          let element = rs.data[index]
          this.$set(element, 'checkedModule', [])
          if (element.t1.defaultSelected) {
            element.t1.disabled = true
            element.checkedModule.push(element.t1.id)
          }
          if (element.t1.selected) {
            element.checkedModule.push(element.t1.id)
          }
          this.$set(element, 'checkedPermission', [])
          for (let index = 0; index < element.t2.length; index++) {
            let innerEle = element.t2[index]
            if (innerEle.defaultSelected) {
              innerEle.disabled = true
              element.checkedPermission.push(innerEle.id)
            }
            if (innerEle.selected) {
              element.disabled = true
              element.checkedPermission.push(innerEle.id)
            }
            let selected = _.filter(element.t2, 'selected')
            if (innerEle.basisPermission && innerEle.selected && selected && selected.length > 1) {
              innerEle.disabled = true
            }
          }
        }
        this.permissionData = _.cloneDeep(rs.data)
        this.clonedPermission = _.cloneDeep(rs.data)
      })
    },

    clickRole (item) {
      this.activeRole = item.middle
      this.initPermission(item.middle)
      if (item.right) {
        this.initMembers(item.middle)
      }
    },

    addPerson () {
      this.$xhrGet(`/acc/preset-roles/members/optional`).then(rs => {
        if (!_.isEmpty(rs.data)) {
          this.editorVisible = true
          this.roleInfo.name = _.cloneDeep(this.roleName.split('-')[1])
          this.roleInfo.id = _.cloneDeep(this.activeRole)
          this.roleInfo.person = _.cloneDeep(_.map(this.persons, 'value'))
          this.$set(this.roleInfo, 'availablePerson', rs.data)
        } else {
          this.$message.error('当前学校暂无可配置权限的教师')
        }
      })
    },

    deletePerson (person) {
      let param = {
        roleId: this.activeRole
      }
      this.$xhrDelete(`/acc/preset-roles/members/${person.value}`, { params: param }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initMembers(this.activeRole)
        }
      })
    },

    changeModule (val, scope) {
      if (val.length > 0) {
        scope.checkedPermission = _.map(scope.t2, 'id')
      } else {
        scope.checkedPermission = []
        let basisPermissionArr = _.filter(scope.t2, { basisPermission: true })
        for (let index = 0; index < basisPermissionArr.length; index++) {
          let element = basisPermissionArr[index]
          element.disabled = false
        }
      }
    },

    changePoint (val, scope) {
      if (val.length > 0) {
        scope.checkedModule = []
        scope.checkedModule.push(scope.t1.id)
        let basisPermissionArr = _.filter(scope.t2, { basisPermission: true })
        let basisPermissionIdArr = _.map(basisPermissionArr, 'id')
        let temp = _.cloneDeep(scope.checkedPermission)
        temp.push(...basisPermissionIdArr)
        temp = _.uniq(temp)
        scope.checkedPermission = temp
        // 禁用basisPermission为true选项
        for (let index = 0; index < basisPermissionArr.length; index++) {
          let element = basisPermissionArr[index]
          this.$set(element, 'disabled', true)
        }
        // 若只剩下basisPermission为true选项选中，取消disabled
        if (val.length === 1 && val[0] === basisPermissionIdArr[0]) {
          if (!basisPermissionArr[0].defaultSelected) {
            this.$set(basisPermissionArr[0], 'disabled', false)
          }
        }
      } else {
        scope.checkedModule = []
        scope.t1.disabled = false
      }
    },

    saveConfig () {
      let moduleIds = _.flatten(_.map(this.permissionData, 'checkedModule'))
      let pointIds = _.flatten(_.map(this.permissionData, 'checkedPermission'))
      let permissionIds = _.unionWith(moduleIds, pointIds)
      let params = {
        permissionIds: permissionIds
      }
      this.$xhrPost(`/acc/preset-roles/${this.activeRole}/permissions`, params).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('保存成功')
          this.initPermission(this.activeRole)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 128px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
.role-container {
  margin-top: 15px;
  line-height: 40px;
}
.role-container /deep/ .el-button + .el-button {
  margin-left: 0;
}
.role-container /deep/ .el-button--primary.is-plain {
  min-width: 120px;
  margin-right: 20px;
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.role-container /deep/ .el-button--primary.is-plain.actived {
  min-width: 120px;
  margin-right: 20px;
  background: #eeeefd;
  color: var(--theme-color);
  border-color: var(--theme-color);
}
.role-manage-span {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}
.add-person {
  margin-top: 15px;
  padding: 20px;
}
.add-person /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.add-person /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.add-person /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.el-tag {
  height: 36px;
  line-height: 34px;
}
.permisson-set {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/permission/PermissionManage.vue